var MIN_W = 28;
var MIN_H = 22;
/**
 * Resize a box from a handle while anchoring the opposite edge/corner.
 * Outward drag grows; inward drag shrinks (clamped to min size).
 */
export function applyAnchoredResize(start, handle, pointerX, pointerY, minW, minH) {
    if (minW === void 0) { minW = MIN_W; }
    if (minH === void 0) { minH = MIN_H; }
    var right0 = start.x + start.width;
    var bottom0 = start.y + start.height;
    var left = start.x;
    var top = start.y;
    var right = right0;
    var bottom = bottom0;
    switch (handle) {
        case 'e':
            right = Math.max(pointerX, left + minW);
            break;
        case 'w':
            left = Math.min(pointerX, right - minW);
            break;
        case 's':
            bottom = Math.max(pointerY, top + minH);
            break;
        case 'n':
            top = Math.min(pointerY, bottom - minH);
            break;
        case 'se':
            right = Math.max(pointerX, left + minW);
            bottom = Math.max(pointerY, top + minH);
            break;
        case 'sw':
            left = Math.min(pointerX, right - minW);
            bottom = Math.max(pointerY, top + minH);
            break;
        case 'ne':
            right = Math.max(pointerX, left + minW);
            top = Math.min(pointerY, bottom - minH);
            break;
        case 'nw':
            left = Math.min(pointerX, right - minW);
            top = Math.min(pointerY, bottom - minH);
            break;
    }
    return {
        x: left,
        y: top,
        width: Math.max(minW, right - left),
        height: Math.max(minH, bottom - top),
    };
}
export var RESIZE_HANDLES = [
    { id: 'nw', u: 0, v: 0 },
    { id: 'n', u: 0.5, v: 0 },
    { id: 'ne', u: 1, v: 0 },
    { id: 'e', u: 1, v: 0.5 },
    { id: 'se', u: 1, v: 1 },
    { id: 's', u: 0.5, v: 1 },
    { id: 'sw', u: 0, v: 1 },
    { id: 'w', u: 0, v: 0.5 },
];
